//Import required libraies
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

//Import Custom Component
import TableRow from "../../../components/TableRow/TableRow";
import FiltersNew from "../../../components/Filters/FilterNew";
import AppRow from "../../../components/AppRow/AppRow";
import Loader from "../../../components/Loader/Loader";
import noDataImage from "../../../../assets/images/undraw_empty.svg";

//Import utils & data
import {
  splitConfigsByCategory,
  filterMyConfigs,
  makeDefaultResponseJson,
  checkConfigurationCountryAndBrand,
} from "../../../utils/utils";
import { config } from "../../../config/config";

// Import action creators
import {
  updateData,
  updateUserInfo,
  updateAlertInfo,
} from "../../../redux/actions";

//Import hooks
import { useFirstRender } from "../../../hooks/useFirstRender";

function StarredConfigurations(props) {
  let {
    match,
    user,
    allData,
    updateData,
    updateUserInfo,
    changeFlag,
    updateAlertInfo,
    handleSwitch,
    switchScheduleConfiguration,
  } = props;
  const [configs, setConfigs] = useState(false);
  const [configsLoading, setConfigsLoading] = useState(true);
  const [savedConfigsLoading, setsavedConfigsLoading] = useState(true);
  const [sharedConfigLoading, setSharedConfigLoading] = useState(true);
  const isFirstRender = useFirstRender();
  const history = useHistory();
  let app = config.hardCoded.mroiAppId.toLowerCase();
  let activeApp =
    allData.apps.data.length > 0
      ? allData.apps.data.find(
          (obj) => obj.name.toLowerCase() === app.toLowerCase()
        )
      : null;

  // Get apps data
  useEffect(() => {
    if (!allData.apps.data) {
      let url = `${config.api.appsUrl}?vertical=${config.hardCoded.defaultVertical}&app_id=${activeApp?.id}`;
      let status;
      fetch(url)
        .then((response) => {
          console.groupCollapsed("requesting", url);
          console.log("REPSONSE -> ", response);
          status = response.status;
          return response.clone().json();
        })
        .then((json) => {
          console.log("JSON -> ", json);
          console.groupEnd();
          if (status === 200) {
            let allAppsName = json.data?.map((appName) =>
              appName.name?.toLowerCase()
            );
            if (!allAppsName.includes(activeApp?.id)) {
              updateAlertInfo({
                open: true,
                message: config.messages.noAppsAccess,
                severity: "info",
              });
              history.push(`/home/`);
            }
            updateData("apps", {
              status: "success",
              data: json.data,
              message: "",
            });
          } else {
            updateAlertInfo({
              open: true,
              message: json.statusMessage,
              severity: "error",
            });
          }
        });
    }
    return () => {};
  }, []);

  //reload starred_configurations data
  useEffect(() => {
    if (activeApp && !isFirstRender.current) {
      let url = `${config.api.bookmarkUrl}?app_id=${activeApp.id}`;
      updateData("starred_configurations", {
        status: "loading",
        message: "",
        data: [],
      });
      setConfigsLoading(true);
      let status;
      fetch(url)
        .then((response) => {
          console.groupCollapsed("requesting", url);
          console.log("REPSONSE -> ", response);
          status = response.status;
          return response.clone().json();
        })
        .then((json) => {
          console.log("JSON -> ", json);
          console.groupEnd();
          if (status === 200) {
            if (allData.appAccessDetails?.feature_list?.schedule_run) {
              let responseData = json.data;
              let url = `${config.api.scheduleConfigurl}?app_id=${activeApp.id}`;
              let status;
              fetch(url)
                .then((response) => {
                  console.groupCollapsed("requesting", url);
                  console.log("REPSONSE -> ", response);
                  status = response.status;
                  return response.clone().json();
                })
                .then((json) => {
                  console.log("JSON -> ", json);
                  console.groupEnd();
                  if (status === 200) {
                    let updatedSavedConfigurations = responseData?.map(
                      (elem) => ({
                        ...elem,
                        ...(json?.data?.find(
                          (obj) => obj.config_id === elem.id
                        ) && {
                          schedule_details: json.data.find(
                            (obj) => obj.config_id === elem.id
                          ),
                        }),
                      })
                    );
                    updateData("starred_configurations", {
                      status: "success",
                      message: "",
                      data: updatedSavedConfigurations,
                    });
                    setConfigsLoading(false);
                  } else {
                    updateAlertInfo({
                      open: true,
                      message: json.statusMessage,
                      severity: "error",
                    });
                    setConfigsLoading(false);
                  }
                });
            } else {
              updateData("starred_configurations", {
                status: "success",
                message: "",
                data: json.data,
              });
              setConfigsLoading(false);
            }
          } else {
            updateAlertInfo({
              open: true,
              message: json.statusMessage,
              severity: "error",
            });
            setConfigsLoading(false);
          }
        });
    }
    return () => {};
  }, [changeFlag.reloadConfigs]);

  // Change table if starred_configurations changes
  useEffect(() => {
    if (allData.starred_configurations.data) {
      let filtered_starred_configurations = filterMyConfigs(
        allData.starred_configurations.data,
        "name",
        user.selections,
        true
      );

      let configArr = splitConfigsByCategory({
        category: match.params.tab,
        arr: filtered_starred_configurations,
      });

      setConfigs({ filtered_starred_configurations, configArr });
    }
  }, [
    allData.starred_configurations.status,
    user.selections,
    match.params.tab,
  ]);

  //reload saved_configurations data
  useEffect(() => {
    if (activeApp && !isFirstRender.current) {
      let url = `${config.api.configsUrl}?app_id=${activeApp.id}`;
      let status;
      setsavedConfigsLoading(true);
      fetch(url)
        .then((response) => {
          console.groupCollapsed("requesting", url);
          console.log("REPSONSE -> ", response);
          status = response.status;
          return response.clone().json();
        })
        .then((json) => {
          console.log("JSON -> ", json);
          console.groupEnd();
          if (status === 200) {
            if (allData.appAccessDetails?.feature_list?.schedule_run) {
              let responseData = json.data;
              let url = `${config.api.scheduleConfigurl}?app_id=${activeApp.id}`;
              let status;
              fetch(url)
                .then((response) => {
                  console.groupCollapsed("requesting", url);
                  console.log("REPSONSE -> ", response);
                  status = response.status;
                  return response.clone().json();
                })
                .then((json) => {
                  console.log("JSON -> ", json);
                  console.groupEnd();
                  if (status === 200) {
                    let updatedSavedConfigurations = responseData?.map(
                      (elem) => ({
                        ...elem,
                        ...(json?.data?.find(
                          (obj) => obj.config_id === elem.id
                        ) && {
                          schedule_details: json.data.find(
                            (obj) => obj.config_id === elem.id
                          ),
                        }),
                      })
                    );
                    updateData(
                      "saved_configurations",
                      updatedSavedConfigurations
                    );
                    setsavedConfigsLoading(false);
                  } else {
                    updateAlertInfo({
                      open: true,
                      message: json.statusMessage,
                      severity: "error",
                    });
                    setsavedConfigsLoading(false);
                  }
                });
            } else {
              updateData("saved_configurations", json.data);
              setsavedConfigsLoading(false);
            }
          } else {
            updateAlertInfo({
              open: true,
              message: json.statusMessage,
              severity: "error",
            });
            setsavedConfigsLoading(false);
          }
        });
    }
    return () => {};
  }, [changeFlag.reloadConfigs]);
  //reload shared_configurations data
  useEffect(() => {
    if (activeApp && !isFirstRender.current) {
      let url = `${config.api.sharedConfigsUrl}?app_id=${activeApp?.id}`;
      setSharedConfigLoading(true);
      let status;
      fetch(url)
        .then((response) => {
          console.groupCollapsed("requesting", url);
          console.log("REPSONSE -> ", response);
          status = response.status;
          return response.clone().json();
        })
        .then((json) => {
          console.log("JSON -> ", json);
          console.groupEnd();
          if (status === 200) {
            updateData("shared_configurations", json.data);
            setSharedConfigLoading(false);
          } else {
            updateAlertInfo({
              open: true,
              message: json.statusMessage,
              severity: "error",
            });
            updateUserInfo({ error: json.error, errorCode: json.errorCode });
            setSharedConfigLoading(false);
          }
        });
    }
    return () => {};
  }, [changeFlag.reloadConfigs]);

  const prepareRowObj = (obj) => {
    obj = checkConfigurationCountryAndBrand(allData, obj);
  };

  return (
    <>
      <FiltersNew
        match={match}
        activeApp={activeApp}
        handleSwitch={handleSwitch}
        switchScheduleConfiguration={switchScheduleConfiguration}
      />
      {configsLoading || savedConfigsLoading || sharedConfigLoading ? (
        <Loader />
      ) : configs.filtered_starred_configurations.length ? (
        <>
          {configsLoading && <Loader />}
          <div
            className={`my-configs-container ${
              configsLoading ? "disabled-pointer" : ""
            }`}
          >
            {user.selections.appView == "table"
              ? configs.configArr.map((obj) => {
                  prepareRowObj(obj);
                  return (
                    <TableRow
                      key={obj.key}
                      title={obj.title}
                      match={match}
                      data={
                        switchScheduleConfiguration
                          ? obj.data.filter((item) =>
                              item.hasOwnProperty("schedule_details")
                            )
                          : obj.data
                      }
                    />
                  );
                })
              : configs.configArr.map((obj) => {
                  prepareRowObj(obj);
                  return (
                    <AppRow
                      key={obj.key}
                      title={obj.title}
                      match={match}
                      data={
                        switchScheduleConfiguration
                          ? obj.data.filter((item) =>
                              item.hasOwnProperty("schedule_details")
                            )
                          : obj.data
                      }
                      popOverFlag={true}
                    />
                  );
                })}
          </div>
        </>
      ) : (
        <div className="no-configs">
          <img src={noDataImage} />
          <p className="no-data">
            <b>{config.messages.noConfigs}</b>
          </p>
        </div>
      )}
    </>
  );
}

StarredConfigurations.propTypes = {
  user: PropTypes.object,
  match: PropTypes.object,
  saved_configurations: PropTypes.array,
  updateData: PropTypes.func,
  starred_configurations: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  changeFlag: state.changeFlag,
});

const mapDispatchToProps = {
  updateData,
  updateUserInfo,
  updateAlertInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StarredConfigurations);
